import {
  Button,
  useDisclosure,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from '@chakra-ui/react';
import React from 'react';
import { Navigate } from 'react-router-dom';

import { UpsizeSearchSelectModal } from './UpsizeExistingLoanModal';
import { OriginateLoanModal } from 'packages/funding-requests/ui/submit/CreateRequest/CreateRequestButton/OriginateLoanModal';
import {
  PermissionsFn,
  PermissionGuard,
  usePermissionGuard,
} from '~/core/PermissionGuard';
import { Icon } from '~/packages/common-frontend/components/icons';

const upsizePermissions: PermissionsFn = (context) => {
  if (context.user.userType === 'CAPITAL_PROVIDER') {
    return context.flags.productsFundingRequestsLenderUpsizePermissions;
  }
  return context.flags.productsFundingRequestsUpsizePermissions;
};

const createPermissions: PermissionsFn = (context) => {
  if (context.user.userType === 'CAPITAL_PROVIDER') {
    return context.flags.productsFundingRequestsLenderCreatePermissions;
  }
  return context.flags.productsFundingRequestsCreatePermissions;
};

const menuPermissions = (context: any) => {
  const upsizePermission = upsizePermissions(context);
  const createPermission = createPermissions(context);

  if (upsizePermission === 'deny' || createPermission === 'deny') {
    return 'deny';
  }

  return 'allow';
  // only show menu is either both allowed, or any combination of upsell
};

export const CreateFundingRequestMenu = () => {
  const createPermission = usePermissionGuard(createPermissions);
  const upsizePermission = usePermissionGuard(upsizePermissions);
  const originateModalControls = useDisclosure();
  const upsizeModalControls = useDisclosure();
  return (
    <>
      <Menu>
        <MenuButton
          as={Button}
          variant="secondary"
          colorScheme="v2-aurora"
          rightIcon={<Icon icon="chevron-down" />}
        >
          Create Request
        </MenuButton>
        <MenuList>
          {/* // @jendevelops TODO: differentiate between deny and upsell */}
          <MenuItem
            onClick={originateModalControls.onOpen}
            isDisabled={createPermission !== 'allow'}
          >
            Originate Loan
          </MenuItem>
          <MenuItem
            onClick={upsizeModalControls.onOpen}
            isDisabled={upsizePermission !== 'allow'}
          >
            Upsize Existing Loan
          </MenuItem>
        </MenuList>
      </Menu>
      <OriginateLoanModal modalControls={originateModalControls} />
      {/* @jendevelops TODO: may need to lazy load this component because we're currently fetching all loans metadata, but will implement "fuzzy" search. For now trying to only load it if the modal is open  */}
      {upsizeModalControls.isOpen && (
        <UpsizeSearchSelectModal upsizeModalControls={upsizeModalControls} />
      )}
    </>
  );
};

// Exports
export const CreateFundingRequestOriginationOnlyButton = () => {
  const modalControls = useDisclosure();

  return (
    <>
      <Button
        variant="secondary"
        colorScheme="v2-aurora"
        onClick={modalControls.onOpen}
      >
        Create Request
      </Button>
      <OriginateLoanModal modalControls={modalControls} />
    </>
  );
};

export const CreateFundingRequestButton = () => {
  const menuPermission = usePermissionGuard(menuPermissions);
  return menuPermission === 'allow' ? (
    <PermissionGuard
      permissions={menuPermissions}
      fallback={<Navigate to="/funding-requests" replace />}
    >
      <CreateFundingRequestMenu />
    </PermissionGuard>
  ) : (
    <PermissionGuard
      permissions={createPermissions}
      fallback={<Navigate to="/funding-requests" replace />}
    >
      <CreateFundingRequestOriginationOnlyButton />
    </PermissionGuard>
  );
};
